// extracted by mini-css-extract-plugin
export default {"buttons":"ConfirmModal_buttons__chDll"};